import { Button, Popover, Space } from "@mantine/core";
import React from "react";
import { FaTimes } from "react-icons/fa";
import { FiMessageSquare, FiSettings } from "react-icons/fi";
import { HiMenu } from "react-icons/hi";
import { IoMdNotificationsOutline } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { userLogout } from "../../redux/actions/frontendActions/authenticationAction";

const Dashboard_top_header = ({ handleSidebarHideAndShow, sidebarHide }) => {
  const dispatch = useDispatch();
  const { myInfo } = useSelector((state) => state.Auth);
  const handleLogout = () => {
    dispatch(userLogout());
  };

  let timeOfDay;
  const date = new Date();
  const hours = date.getHours();
  const styles = {
    fontSize: 25,
  }

  if (hours < 12) {
    timeOfDay = 'morning';
    styles.color = "#D90000";
  } else if (hours >= 12 && hours < 17) {
    timeOfDay = 'afternoon';
    styles.color = "#04733F";
  } else {
    timeOfDay = 'night';
    styles.color = "#04756F";
  }



  return (
    <div className="dashboard-navbar-flex">
      <div className="left">
        <div className="left-flex">
          <div className="logo">Admin Board</div>
          <div onClick={handleSidebarHideAndShow} className="icon">
            {sidebarHide ? <FaTimes size={40} /> : <HiMenu size={40} />}
          </div>
        </div>
        <div className="nav-greetings">
          {" "}
          <h2 style={styles}>
             Good {timeOfDay}! 😍 
            <span style={{ color: "blue" }}> {myInfo.lastName} </span>
          </h2>
        </div>
      </div>

      <div className="right">
        <div>
          <FiMessageSquare size={25} />
        </div>
        <div>
          <IoMdNotificationsOutline size={30} />
        </div>
        <Popover width={200} position="bottom" withArrow shadow="md">
          <Popover.Target>
            <div className="flex-setting">
              <FiSettings size={30} />
              <img style={{ width: "40px" }} src={myInfo.image} alt="" />
            </div>
          </Popover.Target>

          <Popover.Dropdown>
            <Space h="md" />
            <Link to="#" style={{ color: "#111", textDecoration: "none" }}>
              View profile
            </Link>
            <Space h="md" />
            <Button
              onClick={handleLogout}
              variant="gradient"
              gradient={{ from: "orange", to: "red" }}
            >
              Log out
            </Button>
            <Space h="md" />
          </Popover.Dropdown>
        </Popover>
      </div>
    </div>
  );
};

export default Dashboard_top_header;
